const HeroSection = {
  hero_title_part1: "Easy way",
  hero_title_part2: "to send a package",
  hero_text: "Send a parcel without leaving your home",
  hero_btn: "All companies",
  hero_card_title: "Select delivery route",
  hero_card_section_title1: "From where",
  hero_card_section_text1: "Where will the cargo be shipped from?",
  hero_card_section_title2: "Where",
  hero_card_section_text2: "Where will the cargo be sent?",
  hero_card_section_title3: "Package weight",
  hero_card_section_text3: "Enter the average weight of the package",
  hero_card_btn: "Show results",
  hero_presentation_title1: "Our advantages",
  hero_presentation_text1: "The most advanced delivery service",
  hero_presentation_content1_title1: "Will be taken from the address",
  hero_presentation_content1_text1:
    "You no longer need to leave the house to ship the cargo",
  hero_presentation_content1_title2: "Affordable and safe delivery",
  hero_presentation_content1_text2: "Send parcels from $1 *",
  hero_presentation_content1_title3: "Track shipments",
  hero_presentation_content1_text3: "You can track where your cargo is located",

  hero_presentation_title2: "How to send a parcel?",
  hero_presentation_text2: "Shipping Details",
  hero_presentation_content2_title1: "Packaging",
  hero_presentation_content2_text1:
    "Measure your cargo to be shipped and choose a shipping company",
  hero_presentation_content2_title2: "Preparation",
  hero_presentation_content2_text2:
    "The courier takes your cargo from your address on the same day, packs it and prepares it for shipment.",
  hero_presentation_content2_title3: "Sending and tracking",
  hero_presentation_content2_text3:
    "When your cargo is in transit, you can track it by the provided track number.",
};

const HomeFAQ = {
  home_faq_title: "Frequently Asked Questions",
  home_faq_tab1: "General",
  home_faq_tab2: "Support",
  home_faq_tab3: "About sending",
  home_faq_tab1_question1: "How to ship the cargo?",
  home_faq_tab1_question2: "How can I track my cargo?",
  home_faq_tab1_question3: "How many days will it take to deliver?",
  home_faq_tab1_question4: "What should I pay attention to?",
  home_faq_tab1_question5: "How is the payment made?",
};

const Blog = {
  blog_title: "Blog",
  blog_text: "Articles ",
  blog_card_delivery: "Shipment",
  blog_card_coupon: "Coupon",
  blog_card_discount: "DISCOUNT",
};

const FormControls = {
  smart_sorting: "Smart sorting",
  by_rating: "By rating",
  by_price: "By price",
  by_delivery_speed: "By the speed of delivery",
  oldest_comments: "The oldest reviews",
  newest_comments: "Latest comments",
  all_comments: "All comments",
};

const ProductCard = {
  day: "Days",
  fast_delivery: "Fast delivery",
  highlights: "Recommended",
  new_companies: "New companies",
  product_card_delivery: "Delivery",
  product_card_kg_price: "Price per kg",
  product_card_minimum: "Minimum weight",
};

export const Header = {
  header_search: "Search",
  header_btn: "Track cargo",
  current_language: "English",
};

export const Footer = {
  footer_copyright: "All rights reserved © 2021",
  footer_link_title1: "Company",
  footer_link_title2: "General",
  footer_link_about: "About us",
  footer_link_services: "Services",
  footer_link_blog: "Blog",
  footer_link_policy: "Privacy Policy",
  footer_link_companies: "Companies",
  footer_link_faq: "Frequently Asked Questions",
  footer_subscription_title: "Join us",
  footer_subscription_input: "Write your Email",
  footer_coded_by_me: "Coded by Bilkan Konus"
};

export const SiteNav = {
  adressess: "My addresses",
  cargos: "My loads",
  settings: "Settings",
  track_cargo: "Track the shipment",
  logout: "Exit",
  search: "Search",
  account: "Profile",
};

const Info = {
  total_founded: "Found",
  cargo_companies: "Companies",
  company: "companies",
  comment: "Reviews",
  membership_date: "Registration date",
  cargo_price: "Shipping cost",
  starting_price: "",
  about: "hakkında",
  minimum_shipment_abbreviated: "Minimum weight",
  tooltip_price_may_vary:
    "Depending on the product being shipped, there may be a difference in price.",
};

const Comment = {
  company_response: "The Company's response",
  comments_loading: "Loading",
  add_comment: "Add a review",
  comment_question:
    "Have you received services from this company? Write your opinion",
  share_your_opinion: "Share your opinion",
  share: "Share",
};

const Actions = {
  call_courier: "Call a courier",
  report_company: "Report a company",
  accept_and_call_courier: "Call a courier",
  go_to_homepage: "To main page",
  action_track_cargo: "Track cargo",
  action_update_info: "Update data",
  action_cancel: "Cancel",
  action_add_new_address: "Add a new address",
  action_change: "Change",
  action_change_password: "Change Password",
  action_apply: "Apply",
  action_save_address: "Save Address",
  action_show_results: "Show results",
  action_comment: "Write a review",
  action_go_to_profile: "Profile",
  action_show_all: "Show all",
};

const Paths = {
  home_page: "Home page",
  all_companies: "All companies",
  path_call_courier: "Courier call",
};

const Form = {
  form_calling_courier_and_prica_calculator: "Courier call",
  form_shipper: "Sender",
  form_name_surname: "First Name Last Name",
  form_tel: "Phone number",
  form_shipping_address: "Where to pick up the cargo from",
  form_address_details: "Detailed address",
  form_recipient: "Recipient",
  form_warn_empty: "This field cannot be empty",
  form_delivery_address: "Delivery address",
  form_what_to_ship: "What do you want to send?",
  form_what_to_ship_desc:
    "Depending on the product being shipped, there may be a difference in price.",
  form_cargo_weight: "Shipping weight",
  form_box_weight: "Package Weight",
  form_cargo_receival_date: "Date of receipt of your cargo",
  form_date_select_today: "Today",
  form_date_select_tomorrow: "Tomorrow",
  form_date_custom: "Select a date",
  form_note: "Comment",
  form_note_optional: "Optional",
  form_privacy_policy: "I have read and accept the terms",
  form_country: "City",
  form_district: "District",
  form_error: "Error",
  form_country_land: "Country",
  form_do_you_have_coupon: "Do you have a coupon?",
  form_enter_coupon_code: "Enter the coupon code",
};

const TotalCard = {
  total_card_title: "General",
  total_card_shipper: "Sender",
  total_card_recipient: "Recipient",
  total_card_cargo_route: "Parcel route",
  total_shipment_weight: "Package Weight",
  total_price_title: "Prices",
  total_cargo_price: "Shipping cost",
  total_service_price: "Service fee",
  total_free: "Free",
  total_sum: "Total amount",
  total_coupon_discount: "Coupon discount",
};

const Modal = {
  member_login: "Login",
  modal_new_membership: "New registration",
  password_proccess: "Password Recovery",
  modal_tel: "Phone number",
  forgot_password: "Forgot my password",
  login: "Sign in",
  password: "Password",
  login_via_social: "Log in using",
  no_account_question: "Don't you have an account?",
  have_account_question: "Do you have an account?",
  modal_sign_up: "Sign up",
  remember_me: "Remember me",
  password_again: "Repeat the password",
  renew_password: "Update Password",
  sms_verification: "SMS confirmation",
  accept_and_continue: "Confirm",
  send_code_again: "Send the code again",
  enter_4_digit_number: "Enter the 4-digit code",
  modal_register: "Sign up",
  modal_enter_tel_text:
    "Enter your phone number that you used when registering",
  modal_cargo_track: "Package tracking",
  modal_enter_track_number: "Enter the track number",
  track_no: "Track number",
};

const InfoPages = {
  info_thanks: "Thank you!",
  info_no_order_created: "the application has been created.",
  info_shipping_process: "You can track the delivery process",
  info_profile: "In profile",
  info_from_page_follow: "",
  info_track_number: "Track number",
};

const ProfilePage = {
  profile_notifications: "Notifications",
  profile_enter_track_number: "Enter the track number",
  profile_cargo_status_title: "Delivery Status",
  profile_cargo_situation_onway: "Your package is on the way",
  profile_cargo_situation_delivered: "Delivered",
  profile_track_no: "Track number",
  profile_cargo_from: "Place of dispatch",
  profile_cargo_to: "Place of delivery",
  profile_cargo_date: "Date of dispatch",
  profile_price: "Price",
  profile_all_cargos: "All parcels",
  profile_on_the_way: "On the way",
  profile_completed: "Delivered",
  profile_all: "All",
  profile_cargo_id: "Package ID",
};

const Settings = {
  settings_support_text: "To change your email, write to us.",
  settings_title: "Settings",
  settings_write_message: "Write",
  settings_current_password: "Current password",
  settings_new_password: "New password",
  settings_new_password_again: "Repeat the new password",
};

const MyAdresses = {
  my_addresses_title: "My addresses",
  address: "Address",
};

const AddAddress = {
  add_address_name: 'Address desc. ("House", "Office" etc.)',
  add_address_city: "City",
  add_address_district: "District",
  add_address_details: "Address",
};

const NotFound = {
  not_found_title: "Page not found",
  not_found_text:
    "Perhaps the page you are looking for has been deleted, or the address is incorrect.",
};

const CargoTrack = {
  cargo_track_title: "Cargo movement",
  cargo_track_cargo_accepted: "Package accepted",
  cargo_track_shipped: "Sent to the destination country",
  cargo_track_arrived: "Delivered to the destination country",
  cargo_track_at_branch: "Your parcel is at the depot",
  cargo_track_out_for_distribution: "Being delivered",
  cargo_track_delivered: "Delivered",
  cargo_track_last_update: "Last change",
  cargo_track_no: "Track number of the parcel",
  cargo_track_tel: "Phone number",
  cargo_track_sum: "Total amount",
};

const FAQ = {
  faq_search_title: "Search for questions",
  faq_search_text:
    "You can quickly come to a solution by searching for the questions asked.",
  faq_title: "Frequently Asked Questions",
  faq_search_placeholder: "Search for questions",
  faq_text_part1: "If you can't find the answer you're looking for",
  faq_support_link: "You can write",
  faq_text_part2: "to us",
  faq_tab1: "General",
  faq_tab2: "About the package",
  faq_tab3: "Questions",
};

const CompanyCard = {
  company_card_free_packaging: "Free packaging",
};

const Extra = {
  blog_similar_blogs: "Similar blogs",
};

const Toast = {
  toast_success_title: "Successful",
  toast_error_title: "Error",
  toast_warn_title: "Attention",
  toast_info_title: "Notification",
  toast_success_text: "The operation was performed successfully.",
  toast_error_text: "Something went wrong.",
  toast_warn_text: "Notification text",
  toast_info_text: "Notification text",
};

export const Shared = {
  ...Footer,
  ...SiteNav,
  ...FormControls,
  ...ProductCard,
  ...Info,
  ...Paths,
  ...Comment,
  ...Actions,
  ...TotalCard,
  ...Form,
  ...Modal,
  ...InfoPages,
  ...ProfilePage,
  ...Settings,
  ...MyAdresses,
  ...AddAddress,
  ...NotFound,
  ...CargoTrack,
  ...FAQ,
  ...CompanyCard,
  ...Extra,
  ...Toast,
};

export const HomePage = {
  ...HeroSection,
  ...HomeFAQ,
  ...Blog,
};
